module.exports = __webpack_public_path__ + "media/img/raport-dane-bcg@2x-fa7cc456.png";